// extracted by mini-css-extract-plugin
export default {"wrapper":"Distance_wrapper__S3Bqy"};